//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import global from '../../assets/js/global'
import { Toast } from 'vant'
import { insertData } from '../../assets/js/sql'
import { chatV4Params } from '@/api/create'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
export default {
  name: 'createDetail1',
  data: function () {
    return {
      title: '',
      mapData: {},
      spaceEnable: false,
      userInfo: {},
      concreteness: {
        template: {},
        spaceData: {},
      },
      spaceData: {},
      top: 0,
      bottom: 0,
      contentH: 0,
      picContentH: 0,
      startIndex: 0,
      showPreView: false,
      shareFriendModal: false,
      qrcodeImg: '',
      html2Img: '',
      shareImgW: 0,
      shareImgH: 0,
      shareImgUrl: '',
      showBtn: true,
      positionY: 0,
      result: '',
      data: [],
      activeIndex: -1,
      images: [],
      pictureList: [],
      disabled: false,
      resultH: '200',
    }
  },
  created() {
    this.title = decodeURIComponent(this.$route.query.title)
    this.data = JSON.parse(localStorage.getItem('create-detail'))
    this.concreteness = JSON.parse(this.data.concreteness)
    let values = this.concreteness.spaceData.map(item => item.value)
    let arr = values.filter(item => item !== '')
    if (!arr.length) {
      this.spaceEnable = false
    } else {
      this.spaceEnable = true
    }
    if (global.isApp) {
      this.top = api.safeArea.top
      this.bottom = api.safeArea.bottom
    }
     // 46 navbar 高度
    // 90 footBtn 高度
    this.contentH = this.top + 46 + 90 + this.bottom
    this.picContentH = this.top + 46 + this.bottom
    console.log(this.data)
  },
  mounted () {
    // this.images = []
    // this.pictureList.forEach(item => {
    //   this.images.push(item.url)
    // })
  },
  activated () {
    this.pictureList = []
    this.images = []
    this.activeIndex = ''
    this.result = ''
    this.concreteness = JSON.parse(this.data.concreteness)
    let values = this.concreteness.spaceData.map(item => item.value)
    let arr = values.filter(item => item !== '')
    if (!arr.length) {
      this.spaceEnable = false
    } else {
      this.spaceEnable = true
    }
  },
  methods: {
    onClickLeft () {
      this.$router.goBack()
    },
    showPic (index) {
      this.showPreView = true
      this.startIndex = index
    },
    focus () {
      if (!this.$global.isApp) {
        return
      }
      this.showBtn = false
    },
    blur () {
      if (!this.$global.isApp) {
        return
      }
      setTimeout(() => {
        this.showBtn = true
      }, 100);
    },
    copy () {
      if (global.isApp) {
        var clipBoard = api.require('clipBoard')
        clipBoard.set(
          {
            value: this.result
          },
          function (ret, err) {
            console.log('复制', ret, err)
            if (ret.status) {
              Toast({
                message: '复制成功',
                duration: 1000,
              })
            } else {
              Toast({
                message: '复制失败',
                duration: 1000,
              })
            }
          }
        )
      } else {
        var input = document.createElement('input');
        input.setAttribute('id', 'copyInput');
        input.setAttribute('value', this.result);
        document.body.appendChild(input);
        document.getElementById('copyInput').select();
        document.execCommand('copy')
        Toast.success("已复制")
        document.body.removeChild(input)
      }
    },
    chooseItem (item, index) {
      this.buyIndex = index
      console.log(item)
    },
    fastFillKeyWord (item, child, index) {
      this.concreteness.template[index].child.forEach(item => {
        if (!child.isCustom) {
          if (item.isCustom) {
            item.value = ''
          }
        }
      })
      this.mapData[index + 1] = child.value
      this.$forceUpdate()
    },
    clearVal(index) {
      this.mapData[index + 1] = ''
    },
    setData(val, index) {
      this.mapData[index + 1] = val
    },
    setText(index, item) {
      this.mapData[index + 1] = item.value
    },
    fastFillSpace(item) {
      this.mapData['篇幅'] = item.value
      this.$forceUpdate()
    },
    generate () {
      let flag = false
      let findex = -1
      for (let i = 1; i < this.concreteness.template.length + 1; i++) {
        if (!this.mapData[i] || this.mapData[i] === '') {
          flag = true
          findex = i
          break
        }
      }
      if (flag) {
        Toast(`请${this.concreteness.template[findex - 1].type === 2 ? '选择' : '输入'}${this.concreteness.template[findex - 1].title}`)
        return
      }
      console.log(this.concreteness.spaceData)
      if (this.spaceEnable && (!this.mapData['篇幅'] || this.mapData['篇幅'] === '')) {
        Toast('请选择篇幅')
        return
      }
      this.disabled = true
      this.$toast.loading({
        message: '努力创作中\n请稍候 ...',
        duration: 0, // 持续展示 toast
        forbidClick: true,
        loadingType: 'spinner'
      })
      let type = this.title
      chatV4Params({
        param: this.mapData,
        type: type
      }).then(res => {
        if (res.code === 405) {
          // setTimeout(() => {
          //   this.$router.push({
          //     path: "/subscribe?type=nobalance",
          //     query: {
          //       from: 'createDetail'
          //     }
          //   });
          // }, 1000);
          this.disabled = false;
          return;
        }
        if (res.code === 200) {
          this.$toast.clear()
          this.disabled = false
          let keyword = res.data.question
          let paramsId = res.data.paramsId
          this.$router.push({
            path: '/chat?type=' + encodeURIComponent(type) + '&paramsId=' + paramsId + '&question=' + res.data.question + '&keyword=' + keyword,
            query: {
              from: 'createDetail'
            }
          })
        }
      }).catch(v => {
        let result = v.message || '网络异常!'
        this.$toast.clear()
        Toast(result)
        this.disabled = false
      })
      // if (this.data.type === 0) {
      //   chatImage({
      //     prompt: this.data.child[0].value,
      //     n: this.data.child[1].value,
      //     sizeType: this.data.child[2].value
      //   }).then(res => {
      //     console.log(JSON.stringify(res.data))
      //     this.pictureList = res.data
      //     this.images = []
      //     this.pictureList.forEach(item => {
      //       this.images.push(item.url)
      //     })
      //     this.disabled = false
      //   }).catch(v => {
      //     this.disabled = false
      //   })
      // } else {
      //   console.log(this.data)
      //   
      // }
    },
    saveConversationDetailData (obj) {
      insertData('conversation_detail', obj).then((res) => {
        console.log("conversation_detail保存成功", res.target.result);
        // "conversationDetailId",
        // "type", //类型
        // "title", //
        // "question", //问题
        // "answer", //回答
        // "createTime", //创建时间
        // "updateTime", //更新时间
        let obj1 = {
          conversationDetailId: res.target.result,
          type: obj.type,
          status: 'normal',
          question: obj.question,
          answer: obj.answer,
          createTime: obj.createTime,
          updateTime: obj.updateTime
        }
        this.saveData(obj1, obj.conversationId)
      });
    },
    saveData (obj, conversationId) {
      let _this = this
      insertData('chat', obj).then((res) => {
        console.log("chat保存成功", res.target.result);
        _this.goChat(obj.type, conversationId)
      });
      this.disabled = false
    },
    // saveData (obj) {
    //   let _this = this
    //   insertData('', obj).then(res => {
    //     console.log('保存成功')
    //     _this.goChat(obj.typeName)
    //   })
    // },
    goChat (type, conversationId) {
      this.$router.push({
        path: '/chat?type=' + encodeURIComponent(type) + '&id=' + conversationId,
        query: {
          from: 'createDetail'
        }
      })
    },
    getDPR(){
        if (window.devicePixelRatio && window.devicePixelRatio > 1) {
            return window.devicePixelRatio;
        }
        return 1;
    },
    /**
     * 将传入值转为整数
     * @param value
     * @returns {number}
     */
      parseValue: function(value) {
      return parseInt(value, 10);
    },
    drawAndShareImage() {
        // 获取像素比
        var scaleBy = this.getDPR();
        let width = this.shareImgW * scaleBy
        let height = this.shareImgH * scaleBy
        let pageH =  window.screen.height * scaleBy // height + footerImgH
        let footerImgW = width
        let footerImgH = footerImgW * 558/1080
        let footerImgX = 0
        let footerImgY = pageH - footerImgH
        
        let imgTop = 15 * scaleBy
        let imgY = imgTop + 5 * scaleBy
        let imgH = pageH - footerImgH - (imgTop * 2)
        let imgW = imgH * width/height
        let imgX = (width - imgW) / 2
    
        var canvas = document.createElement('canvas')
        canvas.width = width;
        canvas.height = pageH;
        var context = canvas.getContext('2d')
        context.rect(0, 0, canvas.width, canvas.height)
        context.fillStyle = 'transparent'
        context.fill()
        var shareBkImg = new Image()
        shareBkImg.src = '../../../static/home/sharebk.png'
        shareBkImg.crossOrigin = 'Anonymous'
        let _this = this
        shareBkImg.onload = function() {
          context.drawImage(shareBkImg, 0, 0, width, pageH)
          // var bkImg = new Image()
          // bkImg.crossOrigin = 'Anonymous'
          // bkImg.onload = function() {
          //   context.drawImage(bkImg, imgX, imgY, imgW, imgH)
          //   console.log('bkImg:', bkImg.width, bkImg.height)
            var domImage = new Image()
            domImage.src = _this.html2Img //背景图片 你自己本地的图片或者在线图片
            domImage.crossOrigin = 'Anonymous'
            domImage.onload = function() {
              context.drawImage(domImage, imgX, imgY, imgW, imgH)
              var footerImg = new Image()
              footerImg.src = '../../../static/home/sharefooter.png' //你自己本地的图片或者在线图片
              footerImg.crossOrigin = 'Anonymous'
              footerImg.onload = function() {
                  context.drawImage(footerImg, footerImgX, footerImgY, footerImgW, footerImgH)
                  var qrcodeDom = document.getElementById('qrcode')
                  console.log(qrcodeDom)
                  let url = process.env.SHARE_HOST + '/home?inviteCode=' + _this.userInfo.inviteCode
                  QRCode.toCanvas(qrcodeDom, url, {
                    errorCorrectionLevel: 'H',
                    type: 'image/png',
                    quality: 0.3,
                    margin: 1
                  },function (error, dom) {
                    if (error) console.error(error)
                    console.log('success!', dom.toDataURL('image/png'));
                    _this.qrcodeImg = dom.toDataURL('image/png')
                    _this.$nextTick(() => {
                      let qrImg = new Image()
                      qrImg.src = _this.qrcodeImg
                      qrImg.onload = () => {
                        context.drawImage(qrImg, width - 15 * scaleBy - (footerImgH/2), pageH - (footerImgH/2) - (footerImgH/3), footerImgH/2, footerImgH/2)
                        var base64 = canvas.toDataURL('image/png') //"image/png" 这里注意一下
                        console.log(base64)
                        _this.shareImgUrl = base64
                        Toast.clear();
                        _this.shareFriendModal = true
                      }
                    })
                  })
              }
            }
        // } 
        }
    },
    shareUrl () {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let _this = this
      const toast = Toast.loading({
        message: '生成中...',
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
      });
      let centerDom =  this.$refs.createDetail  //  document.getElementById('createDetail')
      let box = window.getComputedStyle(centerDom)
      // dom节点计算后宽高
      var width = _this.parseValue(box.width);
      var height = _this.parseValue(box.height);
      this.shareImgW = width
      this.shareImgH = height
      // 获取像素比
      var scaleBy = _this.getDPR();
      console.log(scaleBy)
      // 创建自定义的canvas元素
      var canvas = document.createElement('canvas');

      // 设置canvas元素属性宽高为 DOM 节点宽高 * 像素比
      canvas.width = width * scaleBy;
      canvas.height = height * scaleBy;

      // 设置canvas css 宽高为DOM节点宽高
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      
      // 获取画笔
      var context = canvas.getContext('2d');
      context.fillStyle = 'transparent'
      context.fill()

      // 将所有绘制内容放大像素比倍
      context.scale(scaleBy, scaleBy);

      html2canvas(centerDom, {
        backgroundColor: null,
        width: width,
        height: height
      }).then((canvas) => {
        console.log(canvas)
        this.html2Img = canvas.toDataURL('image/png')
        console.log(this.html2Img)
        this.drawAndShareImage()
      });
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/Create/createDetail.vue